import AuthService from "./AuthService";
import { SystemService } from "./SystemService";

export class StockService{
    systemService = null;
    authService = null;
    api = null;
    fields = [
        {
            code: 'ItemCode',
            name: 'Κωδικός Είδους'
        },
        {
            code: 'ax_ypol',
            name: 'Α/Χ'
        },
        {
            code: 'StringField4',
            name: 'Αριθμός Όγκου'
        },
        {
            code: 'StringField2',
            name: 'Σχιστήριο'
        },
        {
            code: 'Oikogeneia',
            name: 'Οικογένεια'
        },
        {
            code: 'Omada',
            name: 'Ομάδα'
        },
        {
            code: 'Aisth_Katigoria_Perigrafi',
            name: 'Αισθητική Κατηγορία'
        },
        {
            code: 'fTableField5Code',
            name: 'Ποιότητα'
        }
    ];

    textFilters = [
        'ax_ypol',
        'StringField4',
        'StringField2',
        'Oikogeneia',
        'Omada',
        'Aisth_Katigoria_Perigrafi',
        'fTableField10Code'
    ];

    listFilters = [
        'fTableField5Code'
    ];

    lotFields = [
        {
            code: 'LotCode',
            name: 'Παρτίδα'
        },
        {
            code: 'fTableField10Code',
            name: 'Επεξεργασία'
        },
        {
            code: 'Balance',
            name: 'Ποσότητα'
        }
    ]

    constructor(){
        this.systemService = new SystemService();
        this.authService = new AuthService();

        this.api = this.systemService.getApiAccess();
    }

    searchStock(search, page, perPage){
        const stockPromise = new Promise((resolve, reject) => {
            this.api.post('stock', {search, page, perPage}, {
                headers: {
                    'Authorization': `${this.authService.getSessionId()}`
                }
            }).then(r => resolve(r.data)).catch(e => reject(e.message));
        });
        return stockPromise;
    }

    getSearchValues(){
        const searchValuesPromise = new Promise((resolve, reject) => {
            this.api.get('stock/filters', {
                headers: {
                    'Authorization': `${this.authService.getSessionId()}`
                }
            }).then(r => {
                resolve(r.data);
            }).catch(e => reject(e.message));
        });
        return searchValuesPromise;
    }

    getLots(volumeCode){
        const getLotsPromise = new Promise((resolve, reject) => {
            this.api.get(`stock/lots/${volumeCode}`, {
                headers: {
                    'Authorization': `${this.authService.getSessionId()}`
                }
            }).then(r => {
                resolve(r.data);
            }).catch(e => reject(e.message));
        });
        return getLotsPromise;
    }

}